module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_010.png?6fcac41513a07ceb0c2aab230e987dc5";